function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const TwitterIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24.8 4.9c-.7 1-1.5 1.9-2.5 2.6v.7c0 6.7-5.1 14.4-14.4 14.4-2.9 0-5.5-.8-7.8-2.3.4 0 .8.1 1.2.1 2.4 0 4.5-.8 6.3-2.2-2.2 0-4.1-1.5-4.7-3.5.3 0 .6.1 1 .1.5 0 .9-.1 1.3-.2-2.3-.5-4-2.5-4-5v-.1c.7.4 1.5.6 2.3.6C2.1 9.3 1.2 7.7 1.2 6c0-.9.2-1.8.7-2.5 2.5 3.1 6.2 5.1 10.4 5.3-.1-.4-.1-.8-.1-1.2 0-2.8 2.2-5 5-5 1.5 0 2.8.6 3.7 1.6C22 4 23.1 3.6 24.1 3c-.3 1-1.1 2-2.2 2.7 1-.2 2-.4 2.9-.8z"
  }));
};
export default TwitterIcon;